import { MedDataMock } from '../types/history.type'

type IncludedResource = { id: string; type: string; attributes: Record<string, any> }

// Display name for a medical history / encounter problem. The app records problems as linked
// ICD codes; `condition` only exists on older or imported rows, so it is the fallback.
export const getProblemLabel = (
  history: Pick<MedDataMock, 'attributes' | 'relationships'>,
  included?: IncludedResource[]
) => {
  const codeIds = history?.relationships?.icd_codes?.data?.map(({ id }) => id) || []
  const codes = (included || []).filter(({ type, id }) => type === 'icd_code' && codeIds.includes(id))
  const label = Array.from(new Set(codes.map(({ attributes }) => `${attributes.title} - ${attributes.code}`))).join(
    ', '
  )
  return label || history?.attributes?.condition || ''
}
